import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'; 


import { GlobalStyle } from './styles/global';
import { ThemeProvider } from 'styled-components';

import theme from './styles/theme';
import {MuiTheme} from './styles/muiTheme';
import MainRoutes from './MainRoutes';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'


function App() {

  const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            retry:0,
        }
    }
  });

  return (
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <StyledEngineProvider injectFirst>
                <MuiThemeProvider theme={MuiTheme}>
                    <CssBaseline />
                    <GlobalStyle />
                    <ThemeProvider theme={theme}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <MainRoutes />
                        </LocalizationProvider>
                    </ThemeProvider>
                </MuiThemeProvider>
            </StyledEngineProvider>
        </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
